<div class="timesheet__totals">
  <div class="timesheet-totals__time" data-testid="timesheet-total-time">
    {{ time | localeDuration: 'digital' }}
  </div>
  <ng-container *subscriptionPlan="planType.BASIC">
    @if (showSalary) {
      @let formattedSalary = salary | money;
      <div class="timesheet-totals__salary" data-testid="timesheet-total-salary">
        <span class="timesheet-totals__value" [sbTooltip]="formattedSalary">{{ formattedSalary }}</span>
      </div>
      @if (showCoc) {
        @let formattedCoc = coc | money;
        <div class="timesheet-totals__salary" data-testid="timesheet-total-coc">
          <span class="timesheet-totals__value" [sbTooltip]="formattedCoc">{{ formattedCoc }}</span>
        </div>
      }
    }
  </ng-container>
</div>
